import { api } from '../api';

export interface SyncStatus {
  lastSyncedAt: string | null;
}

export async function getSyncStatus(): Promise<SyncStatus> {
  const res = await api.get<SyncStatus>('/system/sync-status');
  return res.data;
}
